import { ReactNode, useState } from "react";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import InformationCircleIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/InformationCircleIconPath";
import styles from "./TaskInfoPanel.module.css";

type TaskInfoPanelBaseProps = {
  label: string;
  sublabel: string;
  value?: number;
  caption: string;
  className?: string;
};

type TaskInfoPanelProps =
  | (TaskInfoPanelBaseProps & {
      infoButtonAriaLabel: string;
      infoContent: (props: {
        visible: boolean;
        onClose: () => void;
      }) => ReactNode;
    })
  | (TaskInfoPanelBaseProps & {
      infoButtonAriaLabel?: never;
      infoContent?: never;
    });

function TaskInfoPanel({
  label,
  sublabel,
  value,
  caption,
  infoButtonAriaLabel,
  infoContent,
  className,
}: TaskInfoPanelProps) {
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  const combinedClassName = className
    ? `${styles["root"]} ${className}`
    : styles["root"];

  return (
    <div className={combinedClassName}>
      {infoContent && (
        <FixaButton
          className={styles["infoButton"]}
          iconOnly
          aria-label={infoButtonAriaLabel}
          ssrIcon={InformationCircleIconPath}
          type="tertiary"
          size="small"
          onClick={() => setInfoModalOpen(true)}
        />
      )}
      <FixaText textStyle="Body.M" className={styles["muted"]}>
        {label}
        {sublabel && <span>{` - ${sublabel}`}</span>}
      </FixaText>
      {value !== undefined && (
        <FixaText textStyle="Heading.L" tagName="p" className={styles["value"]}>
          {value.toLocaleString()}
        </FixaText>
      )}
      <FixaText textStyle="Body.M" className={styles["muted"]}>
        {caption}
      </FixaText>
      {infoContent?.({
        visible: infoModalOpen,
        onClose: () => setInfoModalOpen(false),
      })}
    </div>
  );
}

export default TaskInfoPanel;
